import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons/storage';

import {
  CONFIG_SESSION,
  NEW_FILTER_PATRIMONIO_MANUTENCAO,
  NEW_FILTER_PATRIMONIO_MANUTENCAO_PEDING,
  NEW_FILTER_PATRIMONIO_MANUTENCAO_SUCCESS,
  NEW_FILTER_PATRIMONIO_MANUTENCAO_FAILURE,
} from '@handler';
import { formatDateDDMMYYYY, formatDateYYYYMMDD } from '@components/common/format';
import { filterPatrimonioManutencao } from '../service';
import { CONST_FILTER_PATRIMONIO_MANUTENCAO, CONST_ROWS_PER_PAGE } from '@commons/consts';
import { PATRIMONIO_MANUTENCAO_TYPE_ENUM } from '../patrimonioManutencaoTypeEnum';

function* sagaNewFilterPatrimonioManutencao(action) {
  try {
    yield put({ type: NEW_FILTER_PATRIMONIO_MANUTENCAO_PEDING });

    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    let datas = '';
    let dataInicial = '';
    let dataFinal = '';
    var date = new Date();
    let where = '';
    let filterSaved = sessionStorage.getItem(CONST_FILTER_PATRIMONIO_MANUTENCAO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PATRIMONIO_MANUTENCAO)) : null;

    let newFilter = {
      dataInicial: '',
      dataFinal: '',
      tipo: null,
      identificador: null,
      patrimonio: null,
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE,
      page: filterSaved?.page || 0,
      where: ''
    };

    if (filterSaved === null || filterSaved === undefined) {
      // seta data do mes na primeira vez que entra na pagina
      dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
      dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));

      datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);

      newFilter = {
        ...newFilter,
        dataInicial,
        dataFinal,
        where: where
      };
    } else {
      // se seta filtro manual
      if (action.newFilter) {
        // Quando aplica um novo filtro, volta para a primeira página
        // mas mantém o número de registros por página selecionado pelo usuário
        newFilter.page = 0;

        // seta filtro indicado
        // typePeriodo = 0 -> periodo manual
        // typePeriodo = 1 -> hoje
        // typePeriodo = 2 -> esta semana
        // typePeriodo = 3 -> mes passado
        // typePeriodo = 4 -> este mes
        // typePeriodo = 5 -> proximo mes
        // typePeriodo = 6 -> este ano
        if (action.typePeriodo === undefined || action.typePeriodo === 0) {
          dataInicial = action.args.dataInicial;
          dataFinal = action.args.dataFinal;

          datas = formatDateDDMMYYYY(action.args.dataInicial) + '_' + formatDateDDMMYYYY(action.args.dataFinal);
        } else if (action.typePeriodo === 1) {
          dataInicial = formatDateYYYYMMDD(new Date(date));
          dataFinal = formatDateYYYYMMDD(new Date(date));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        }
        else if (action.typePeriodo === 2) {
          const primeiro = date.getDate() - date.getDay();

          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro + 6));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 3) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() - 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 4) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 5) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 2, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 6) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), 0, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), 12, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        }

        if (action.args.tipo !== null && action.args.tipo !== undefined) {
          const idDB = PATRIMONIO_MANUTENCAO_TYPE_ENUM.find((item) => item.id === action.args.tipo)?.idDB || '';
          where = where + '&tipo=' + idDB;
        }
        if (action.args.patrimonio !== null && action.args.patrimonio !== undefined) {
          where = where + '&patrimonio=' + action.args.patrimonio.id;
        }
        if (action.args.identificador !== null && action.args.identificador !== undefined) {
          where = where + '&identificador=' + action.args.identificador.id;
        }

        newFilter = {
          ...newFilter,
          ...action.args,
          dataInicial,
          dataFinal,
          where: where
        };
      } else {
        // busca filtro salvo
        datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);
        if (filterSaved.tipo !== null && filterSaved.tipo !== undefined) {
          const idDB = PATRIMONIO_MANUTENCAO_TYPE_ENUM.find((item) => item.id === filterSaved.tipo)?.idDB || '';
          where = where + '&tipo=' + idDB;
        }
        if (filterSaved.patrimonio !== null && filterSaved.patrimonio !== undefined) {
          where = where + '&patrimonio=' + filterSaved.patrimonio.id;
        }
        if (filterSaved.identificador !== null && filterSaved.identificador !== undefined) {
          where = where + '&identificador=' + filterSaved.identificador.id;
        }

        newFilter = {
          ...filterSaved,
          where: where
        };
      }
    }

    // busca registros
    const list = yield call(filterPatrimonioManutencao, idFazenda, datas, `&page=${newFilter.page}&size=${newFilter.rows}${where}`);

    sessionStorage.setItem(CONST_FILTER_PATRIMONIO_MANUTENCAO, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_PATRIMONIO_MANUTENCAO_SUCCESS, list: list, filter: newFilter
    });
  } catch (_) {
    yield put({ type: NEW_FILTER_PATRIMONIO_MANUTENCAO_FAILURE });
  }
}

export default function* watchNewFilterPatrimonioManutencao() {
  yield takeLatest(NEW_FILTER_PATRIMONIO_MANUTENCAO, sagaNewFilterPatrimonioManutencao);
}
